module.exports = __webpack_public_path__ + "img/logo.06bce785.jpeg";